import { computed } from 'vue';
import { CampaignLiftExcludedFieldValidator, CampaignType } from '@studyportals/campaign-management-api-interface';
import { ICheckboxEvent } from '@/models/input-events.interface';
import { LoadingStatuses } from '@/models/loading.interface';
import store from '@/store';

export default class CampaignSettingsCheckboxesCode {
	public get userIsNotAllowedToEditCampaignExclusion(): boolean {
		const userId = this.userId;
		const userHasRights = CampaignLiftExcludedFieldValidator.validateRights(userId)
		return !userHasRights;
	}

	private get userId(): number {
		const element = document.querySelector<HTMLDivElement>('.js-campaignEditorPlaceholder');
		if (!element?.dataset.userId) {
			return 0;
		}

		return parseInt(element.dataset.userId);
	}

	public campaignLiftExcluded = computed((): boolean => {
		return store.getters.campaignLiftExcluded();
	});

	public persistGLParamRefLink = computed((): boolean => {
		return store.getters.persistGLParamRefLink();
	});

	public isLoading = computed((): boolean => {
		const loadingStatus = store.getters.loadingStatusPrimaryData();
		return loadingStatus === LoadingStatuses.ACTIVE;
	});

	public campaignLiftExclusionNotAllowedForPartnershipType = computed((): boolean => {
		const partnershipType = store.getters.partnershipType();
		if (partnershipType === null) {
			return true;
		}

		const partnershipTypeAllows = CampaignLiftExcludedFieldValidator.validateData(true, partnershipType);
		return !partnershipTypeAllows;
	});

	public isCampaignTypeCustomProductsOnly = computed((): boolean => {
		return this.campaignType.value === CampaignType.CUSTOM_PRODUCTS;
	});

	private campaignType = computed((): CampaignType | null => {
		return store.getters.campaignType();
	});

	public setCampaignLiftExcludedBasedOnEvent(event: ICheckboxEvent): void {
		const checked = event?.target?.checked;
		if (checked === undefined) {
			return;
		}
		const userId = this.userId;
		const userHasRights = CampaignLiftExcludedFieldValidator.validateRights(userId);
		if (!userHasRights) {
			throw new Error(
				'CampaignSettingsCheckboxes.setCampaignLiftExcludedBasedOnEvent: User is not allowed to edit campaign exclusion.'
			);
		}

		store.mutations.setCampaignLiftExcluded(checked);
	}

	public setPersistGLParamRefLinkBasedOnEvent(event: ICheckboxEvent): void {
		const checked = event?.target?.checked;
		if (checked === undefined) {
			return;
		}

		store.mutations.setPersistGLParamRefLink(checked);
	}
}
